<template>
    <div class="modal fade show">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header my-modal-header">
                    <div class="row">
                        <div class="col-10">
                            <h5 class="mt-0 font-size-12 text-primary">{{ name }}</h5>
                            <p class="card-title-desc">Configurações do Board</p>
                        </div>
                        <div class="col-2">
                            <button type="button" class="btn-close float-end" @click="closeModalConfig()"></button>
                        </div>
                    </div>
                </div>
                <div class="modal-body my-modal-body" v-if="peoples">

                    <ul class="nav nav-pills nav-justified" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link btn" @click="setActive(0)" :class="{ 'active': active === 0 }">
                                <span class="d-none d-sm-block">Pessoas</span>
                            </a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link btn" @click="setActive(1)" :class="{ 'active': active === 1 }">
                                <span class="d-none d-sm-block">Tags</span>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane" :class="{ 'active show': active === 0 }">
                            <div class="row">

                                <div class="col-12 mt-3">
                                    <app-input-search-add-2 :items="peoples" :disabled="false" :defaultValue="null"
                                        label="Pesquise e adicione novos membros ao time." :addNewValue="1"
                                        :key="componentKey" :id="`compoentent-${componentKey}`" :userAdmin="1"
                                        @input="handleAddUser" @updatePropertiesInSelected="handleAddUser" c_css />
                                </div>
                                <div class="col-12 mt-1 mb-2">
                                    <p class="mb-2">({{ teamOrdened.length }}) Membros no time.</p>
                                    <ul class="list-users">

                                        <li v-for="(t, index) of teamOrdened" :key="index"
                                            class="list-group-item p-2">
                                            <a v-if="t.pivot.is_admin === '1'"
                                                @click="setAdmin(t.id, t.pivot.is_admin)">
                                                <i class="bx bxs-check-circle text-success font-size-20"></i>

                                            </a>
                                            <a v-else @click="setAdmin(t.id, t.pivot.is_admin)">
                                                <i class="bx bx bxs-bolt-circle font-size-20"></i>
                                            </a>

                                            <p class="mb-0"><span class="text-muted">{{ t.name }}</span><br /><span
                                                    class="card-title-desc">{{ t.email }}</span>
                                            </p>
                                            <!--
                                            <div>
                                                <button type="button" class="btn btn-danger ml-auto remove-btn"
                                                    v-if="t.pivot.is_admin != '1'" @click.stop="handleRemoveUser(t.id)">
                                                    <i class="mdi mdi-close align-middle"></i>
                                                </button>
                                            </div>
                                            -->

                                        </li>
                                    </ul>
                                </div>
                            </div>


                        </div>
                        <div class="tab-pane" :class="{ 'active show': active === 1 }">
                            <p class="mb-0" v-if="$store.state.users.id === 114">
                                <app-config-tags />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppInputSearchAdd2 from "@/components/AppInputSearchAdd/AppInputSearchAdd2.vue";
import AppConfigTags from "./ConfigTags.vue"
import { mapActions } from "vuex";
export default {
    props: {
        board: {
            type: Number,
            default: 0
        },
        team_id: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: null
        },
        team: {
            type: Array,
            default: () => []
        }
    },
    components: {
        AppInputSearchAdd2,
        AppConfigTags
    },
    data() {
        return {
            active: 0,
            peoples: [],
            teamOrdened: [],
            componentKey: 0
        }
    },
    async created() {
        await this.initTeam(this.team);
        await this.getPeoples();
    },
    methods: {
        ...mapActions([
            "showMessage"
        ]),
        async initTeam(data){
            //this.team = data[0]
            await this.ordenedTeam(data[0])
        },
        closeModalConfig() {
            this.$emit("setModalConfigShow");
            this.$emit("setModalConfigUsers", this.teamOrdened)
        },
        setActive(val) {
            this.active = val;
        },
        async ordenedTeam(p) {
            this.teamOrdened = p.slice().sort((a, b) => a.name.localeCompare(b.name));
            console.log(this.teamOrdened)
        },
        async filterPeoples(data) {
            const idsTeam = new Set(this.teamOrdened.map(user => user.id));
            this.peoples = data.filter(user => !idsTeam.has(user.id));
        },
        async getPeoples() {
            try {
                const response = await this.$AppCallApi("GET", "user");
                if (response.data) {
                    this.filterPeoples(response.data.data.data.user)
                } else {
                    console.log('Resultado de pessoas!')
                    console.log(response)
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        async handleAddUser(v, id) {
            if (v === null) { return; }
            //enviar dados do usuário
            const data = {
                is_admin: String(0),
                team_id: this.team_id,
                user_id: v.id
            }
            const response = await this.$AppCallApi("POST", `user-team-sample`, data);
            if (response.data) {
                this.showMessage({
                    title: 'Adicionado!',
                    css: "bg-success"
                });

                this.peoples = this.peoples.filter(u => {
                    if (u.id != v.id) {
                        return u;
                    }
                });
                //Adicionar o usuário a lista de cadastrados
                const fake = {
                    "id": v.id,
                    "name": v.name,
                    "email": v.email,
                    "pivot": data
                }
                const todos = [...this.teamOrdened, fake];
                //ordenar
                this.ordenedTeam(todos)
                this.componentKey += 1;

            }
        },
        async handleRemoveUser(user) {
            const response = await this.$AppCallApi("DELETE", `user-team/${this.team_id}/${user}`);
            if (response.data) {
                //console.log(response)
                this.showMessage({
                    title: 'Atualizado!',
                    css: "bg-success"
                });

                const index = this.teamOrdened.findIndex(e => e.id === user);
                const userData = this.teamOrdened[index];
                const todos = [...this.peoples, { id: userData.id, name: userData.name, email: userData.email }];
                this.peoples = todos;
                this.teamOrdened = this.teamOrdened.filter(u => {
                    if (u.id != user) {
                        return u;
                    }
                });
            }

        },
        async setAdmin(user, tipo) {

            if (user === 114) {
                this.showMessage({
                    title: 'Você não pode fazer isso!',
                    css: "bg-danger"
                });
                return;
            }

            let nt = tipo === '1' ? 0 : 1;

            const data = {
                is_admin: String(nt)
            };

            const response = await this.$AppCallApi("POST", `user-team/${this.team_id}/${user}`, data);
            if (response.data) {
                //console.log(response)
                this.showMessage({
                    title: 'Atualizado!',
                    css: "bg-success"
                });

                this.teamOrdened = this.teamOrdened.map(u => {
                    if (u.id === user) {
                        this.$set(u.pivot, 'is_admin', data.is_admin);
                    }
                    return u;
                });
            }

            return true;

        }
    }
}
</script>
<style scoped>
.nav-link.btn {
    border-radius: 0px;
    background: transparent;
    color: #000;
}

.nav-link.btn.active {

    color: #000;
    background: #FFF;
}

.nav>.nav-item:first-child>.nav-link.btn {
    border-top-left-radius: 8px;
}

.nav>.nav-item:last-child>.nav-link.btn {
    border-top-right-radius: 8px;
}

ul.list-users {
    max-height: 250px;
    overflow-x: auto;
    border-top: 1px solid #ddd;
    border-radius: 4px;
}

ul.list-users,
ul.list-users li {
    margin: 0px;
    padding: 0px;
    list-style: none;
}

ul.list-users li {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-top: none;
}

ul.list-users li>a {
    margin-right: 10px;
    cursor: pointer;
}

.remove-btn {
    padding: 0px;
    font-size: 14px;
    line-height: 14px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 0px;
    text-align: center;
}

.modal.show {
    display: block;
    background: rgba(0, 102, 255, 0.5);
}

.modal-content {
    box-shadow: 0 0.75rem 1.5rem rgba(255, 255, 255, 0.3);
    background: #f1f2f4;
    border-radius: 0px !important;
}

.tab-content {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
}

.my-modal-header {
    display: block;
}

.my-modal-header,
.modal-body {
    padding: 2rem;
    border: none !important;
}

.my-modal-header {
    padding-bottom: 0rem;
}

.modal-body {
    padding-top: 0rem;
}

.my-modal-header h5 {
    display: block;
}

.btn-close {
    margin-top: -5px;
}

.btn-fixed-right {
    position: fixed;
    float: left;
    right: -200px;
    width: 150px;

}
</style>